import {
    useCallback,
} from 'react'

import StatusHandler from 'app/shared-components/StatusHandler'
import FormWithControls from 'app/shared-components/FormWithControls'
import useEnumValues from 'app/hooks/useEnumValues'
import requestConfig from 'app/requests/Company.requests'
import useFieldsWithClassName from 'app/hooks/useFieldsWithClassName'

import useGetCompany from '../hooks/useGetCompany'
import getFields from './tracking.fields'
import useStyles from './Tracking.styles'

const Tracking = ({
    id,
}: { id: number }) => {
    const {
        classes,
    } = useStyles()

    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useGetCompany(id)

    const getAllowedValues = useEnumValues()

    const fields = useFieldsWithClassName(getFields(getAllowedValues), classes)

    const modifyDataBeforeSend = useCallback(({
        orderTrackingByApi,
    }) => {
        return {
            orderTrackingByApi,
        }
    }, [])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <FormWithControls
                name="Tracking"
                value={data}
                fields={fields}
                requestParams={requestConfig.trackingData({
                    id,
                })}
                onSuccess={invalidate}
                modifyDataBeforeSend={modifyDataBeforeSend}
                exists
            />
        </StatusHandler>
    )
}

export default Tracking
